//회원가입

import { useMutation } from "@tanstack/react-query";
import { joinApi } from "components/api/member";
import { apifield } from "components/utils/comm";
import { useNavigate } from "react-router-dom";
import useAlertStore from "store/alert";

export const useJoinCreateMutate = () => {
  const onSetAler = useAlertStore((state) => state.onSetAlert);
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ["join-create"],
    mutationFn: joinApi,
    onSuccess: (res) => {
      if (res) {
        const {
          status: { code, message },
          data,
        } = res;
        if (code === 0) {
          // 회원 가입 성공
          onSetAler({
            isOpen: true,
            inner:
              "매니저 회원가입이 완료되었습니다. / 관리자 승인 후 로그인이 가능합니다.",
            onSetConfirm: () => {
              navigate("/");
            },
          });
        }
        if (code === -1) {
          apifield(message);
        }
      }
    },
  });
};
